// Checkbox checker
(function($){
    var defaults = {}
    
    $.fn.checkboxChecker = function(options) {
      this.on('click', 'input[type=checkbox]', function(e) {
        var $target = $('body').find($(e.delegateTarget).data('checkbox-checker-target'));
        
        if($(this).is(':checked')) {
          $target.find('input[type=checkbox]').prop('checked', true);
          if ($target.find('tr').length) {
            $target.find('tr').addClass('success'); }
        } else {
          $target.find('input[type=checkbox]').removeProp('checked');
          if ($target.find('tr').length) { $target.find('tr').removeClass('success'); }
        }
      });
    }
})(jQuery);

// Tooltip
(function($){
    $.fn.sbBoTooltip = function() {

        var $this      = this,
            tooltipCls = $this[0].className.match(/(sb-bo-tooltip-left|sb-bo-tooltip-top|sb-bo-tooltip-right|sb-bo-tooltip-bottom)/)[0];
        
        $this.tooltip({
          position     : getPosition(tooltipCls),
          tooltipClass : tooltipCls + " sb-bo-tooltip-box",
          show         : { effect: "show" },
          hide         : { effect: "hide" } 
        });         
        
        function getPosition(cls)
        {
          switch(cls)
          {
            case 'sb-bo-tooltip-left'   : return { my: "right-10 center", at: "left center"}
            case 'sb-bo-tooltip-top'    : return { my: "bottom bottom",   at: "bottom top-10"}
            case 'sb-bo-tooltip-right'  : return { my: "left+10 center",  at: "right center"}
            case 'sb-bo-tooltip-bottom' : return { my: "top top",         at: "top bottom+10"}
            default                     : return { my: "bottom bottom",   at: "bottom top-10"}
          }          
        }
        
        return this;
    };
})(jQuery);

$(document).on('ready page:load', function(){
  $('.sb-bo-tooltip').each(function(){ $(this).sbBoTooltip(); })
});